import React, { useEffect, useRef } from 'react';

function Partners() {
    const partnerRef = useRef(null);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                    entry.target.style.transform = 'translateY(0)';
                }
            });
        }, observerOptions);

        if (partnerRef.current) {
            partnerRef.current.style.opacity = '0';
            partnerRef.current.style.transform = 'translateY(30px)';
            partnerRef.current.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
            observer.observe(partnerRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <section id="partners" className="section partners-section">
            <div className="container">
                <div className="section-header">
                    <span className="section-tag">PARTNERS</span>
                    <h2 className="section-title">협력사 소개</h2>
                    <p className="section-description">
                        하드웨어와 소프트웨어의 완벽한 조화
                    </p>
                </div>
                
                <div className="partner-spotlight" ref={partnerRef}>
                    <div className="partner-content">
                        <div className="partner-info">
                            <div className="partner-logo-text">
                                <span className="partner-name">아이에프</span>
                            </div>
                            <h3>소프트웨어 개발 전문 파트너</h3>
                            <p className="partner-description">
                                IF는 GraceTech의 전략적 협력사로서 소프트웨어 개발 전문 역량을 제공합니다. 
                                하드웨어와 소프트웨어의 통합을 통해 고객에게 완벽한 토탈 솔루션을 제공합니다.
                            </p>
                            
                            <div className="partner-services">
                                <h4><i className="fas fa-code"></i> 주요 서비스</h4>
                                <div className="partner-service-grid">
                                    <div className="partner-service-item">
                                        <i className="fas fa-laptop-code"></i>
                                        <span>임베디드 소프트웨어</span>
                                    </div>
                                    <div className="partner-service-item">
                                        <i className="fas fa-mobile-alt"></i>
                                        <span>모바일 앱 개발</span>
                                    </div>
                                    <div className="partner-service-item">
                                        <i className="fas fa-desktop"></i>
                                        <span>데스크톱 애플리케이션</span>
                                    </div>
                                    <div className="partner-service-item">
                                        <i className="fas fa-cloud"></i>
                                        <span>클라우드 솔루션</span>
                                    </div>
                                    <div className="partner-service-item">
                                        <i className="fas fa-network-wired"></i>
                                        <span>IoT 플랫폼</span>
                                    </div>
                                    <div className="partner-service-item">
                                        <i className="fas fa-database"></i>
                                        <span>데이터 관리 시스템</span>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="partner-benefits">
                                <h4><i className="fas fa-star"></i> 협력 시너지</h4>
                                <ul>
                                    <li><i className="fas fa-check-circle"></i> 하드웨어-소프트웨어 통합 개발</li>
                                    <li><i className="fas fa-check-circle"></i> 펌웨어 및 드라이버 개발</li>
                                    <li><i className="fas fa-check-circle"></i> 제품 전체 라이프사이클 지원</li>
                                    <li><i className="fas fa-check-circle"></i> 원스톱 솔루션 제공</li>
                                </ul>
                            </div>
                        </div>
                        
                        <div className="partner-visual">
                            <div className="integration-diagram">
                                <div className="diagram-item gracetech">
                                    <i className="fas fa-microchip"></i>
                                    <span>GraceTech</span>
                                    <small>하드웨어/PCB</small>
                                </div>
                                <div className="diagram-connector">
                                    <i className="fas fa-plus"></i>
                                </div>
                                <div className="diagram-item if-partner">
                                    <i className="fas fa-code"></i>
                                    <span>IF</span>
                                    <small>소프트웨어</small>
                                </div>
                                <div className="diagram-result">
                                    <i className="fas fa-arrow-down"></i>
                                    <div className="result-box">
                                        <i className="fas fa-check-double"></i>
                                        <span>통합 솔루션</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Partners;
